import { render } from "./Contact.vue?vue&type=template&id=3f3012c8&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=3f3012c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f3012c8"

export default script